import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={26.078}
    height={25.974}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 176973 176268"
    {...props}
  >
    <path
      d="M7874 34952c14487-2021 9891 4292 9947 44900 57 41493 4291 46751-10160 44720l213-89620zm40208 67561c-1926-13974 6156-26845 11686-34470 12704-17519 19602-9575 26045-4889 13379 9726 40590 31213 53517 37299-1690 4425-14474 13741-20081 24288-4329 8141-7771 21858-7774 21853-51-190-223 647-392 936l-42796-30681c-3907-2809-16575-13097-20205-14336zm-5642-2944c259 12650 76448 60250 90306 70061 10727 7600 14269 7328 24331-2206 7233-6853 18909-26067 18614-39164-272-11996-12440-15223-29961-28573L90927 60330c-13507-9452-17221-14125-30728-54-9269 9657-3886 11778-37443 9542-1092-36661 4930-39844-15056-40365-895-5191-590-10680-508-16013C7300 6035 8777 2775 3565 1475-123 7726 1639 139841 2165 159073l-128 10221 5106 416-18-9665 49-690-46-5 118-29187c10957-13 15225 1570 15482-11486 187-9513-205-19224-41-28830l20771-120-1018 9842zm96247 9428 6089-2503c4858 1077 14186 8677 16977 12227-11363 4827-26280 26057-27217 44810l-17013-11294c-2524-17316 10473-34067 21164-43240zm2136 60038c-6771-15615 18863-51812 27922-45795 9083 6031-12365 48375-27922 45795zM45417 83733l-22874 310 64-8331 26183-354-3373 8375z"
      style={{
        fill: "#040404",
        // stroke: "#000",
        strokeWidth: 2564.94,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
